// extracted by mini-css-extract-plugin
module.exports = {"tq6pgfa":"tq6pgfa"};